const categoryPhotoImgixProps = {
  ar: '3:2',
  quality: 30,
  width: 635,
};

export default categoryPhotoImgixProps;
